import {
  ACTIVE_COLOR,
  DISABLE_COLOR,
  INACTIVE_COLOR,
  MENU_COLORS,
} from "@lhd/constants";
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
:root {
  --active-color: ${ACTIVE_COLOR};
  --inactive-color: ${INACTIVE_COLOR};
  --disable-color: ${DISABLE_COLOR};
  --color-thumb-scroll:#7e7e7e;
  --color-track-scroll: #cccccc;
  --animation-blink: blink-strong 0.3s 3;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: unset;
  font-family: 'Noto Sans JP', sans-serif;
}

button{
  padding: .5rem 1rem;
  border: none;
  border-radius: 2rem;
  font-size: 1rem;
  cursor: pointer;
}

p {
  margin-bottom: 0;
}

body {
  position: relative;
}

.ant-checkbox-input:focus+.ant-checkbox-inner, .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner {
  border-color: #174a83
}

.ant-checkbox-checked:after {
  border-color: #174a83
}

.ant-checkbox + span {
  font-size: 13px;
  font-weight: 500;
  transform: translateY(-2px);
}

.ant-select-disabled.ant-select-multiple .ant-select-selection-item {
  color: #000000;
}

input:disabled,
.ant-input[disabled],
.ant-input-affix-wrapper-disabled,
.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
.ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  color: #000000;
  cursor: not-allowed;
}

.ant-spin-dot-item {
  background-color: #174a83;
}

.ant-select-item-option-content,
.ant-select-selection-item {
  font-size: 15px;
  font-weight: 700;
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: #174a83;
  color: #ffffff
}

.ant-select-arrow {
  color: #000000;
  height: 10px;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner {
  &:before {
    border: 1px solid #1e3666;
  }
}

.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #1e3666;
}

.ant-picker-year-panel .ant-picker-cell-inner {
  width: 65px;
}

.ant-picker-today-btn {
  color: #1e3666;
}

.anticon.anticon-check svg {
  color: #ffffff;
}

.ant-select-item {
  border-radius: 4px;
}

.ant-select-item:not(:last-child) {
}

.rc-virtual-list-holder-inner {
  padding: 5px;
}

.ant-select-dropdown {
  border-radius: 6px;
}

.ant-picker-month-panel .ant-picker-header {
  display: none;
}

.month-picker .ant-picker-month-panel .ant-picker-header {
  display: flex !important;
}

.ant-picker-dropdown,
.month-picker-dropdown {
  z-index: 1051 !important;
  
  .ant-picker-month-panel .ant-picker-header {
    display: flex !important;
    visibility: visible !important;
    height: auto !important;
    position: relative !important;
    opacity: 1 !important;
  }
}
.month-item {
  width: 92px;
  font-weight: 400;
  height: 60px;
  padding: 3px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.list-month {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.active-month {
  color: #fff;
  background: #1e3666;
  padding: 3px 8px
}

.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label span:after {
  left: 6px;
  top: 1px;
  width: 7px;
  height: 12px;
}

.reactgrid-content .rg-pane-shadow {
  &.shadow-top,
  &.shadow-top-left-corner,
  &.shadow-top-right-corner {
    box-shadow: none !important;
  }
}

.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell span {
  background-color: #dadada;
}

.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label input {
  z-index: 10000;
}

.ant-pagination-item-link {
  border: none !important;

  &:hover {
    color: #174a83 !important;
  }
}

.ant-pagination-item {
  border-radius: 50%;

  &:hover {
    border-color: #174a83;
    a {
      color: #174a83;
    }
  }

  &.ant-pagination-item-active {
    background-color: #174a83;
    border-color: #174a83;
    a {
      color: #ffffff;
    }
  }

  a {
    font-weight: 700;
    font-size: 15px;
  }
}
.d-flex {
  display: flex !important;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.flex-vertical {
  flex-direction: column;
}
.relative {
  position: relative;
}
.flex-1 {
  flex: 1;
}
.flex-wrap {
  flex-wrap: wrap;
}
.justify-end {
  justify-content: flex-end;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.align-item-center {
  align-items: center;
}
.w-full {
  width: 100%;
}
.mb-24px {
  margin-bottom: 24px;
}

.mb-3 {
  margin-bottom: 32px;
}
.mb-2 {
  margin-bottom: 16px;
}
.mb-1 {
  margin-bottom: 8px;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.mt-1 {
  margin-top: 8px;
}
.mt-2 {
  margin-top: 16px;
}
.mt-3 {
  margin-top: 32px;
}
.ml-1 {
  margin-left: 4px;
}
.ml-2 {
  margin-left: 8px;
}
.ml-3 {
  margin-left: 16px;
}
.ml-4 {
  margin-left: 32px;
}
.pl-1 {
  padding-left: 4px;
}
.pl-2 {
  padding-left: 8px;
}
.pl-3 {
  padding-left: 16px;
}
.pl-4 {
  padding-left: 32px;
}
.pr-1 {
  padding-right: 4px;
}
.pr-2 {
  padding-right: 8px;
}
.pr-3 {
  padding-right: 16px;
}
.pr-4 {
  padding-right: 32px;
}
.mr-1 {
  margin-right: 4px;
}
.mr-2 {
  margin-right: 8px;
}
.mr-3 {
  margin-right: 16px;
}
.mr-4 {
  margin-right: 32px;
}
.fs-3 {
  font-size: 12px;
}
.flex-col {
  flex-direction: column;
}
.p-2 {
  padding: 1rem;
}
.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}
.pb-1 {
  padding-bottom: 4px;
}
.pb-2 {
  padding-bottom: 8px;
}
.pb-3 {
  padding-bottom: 16px;
}
.pb-4 {
  padding-bottom: 32px;
}
.pt-1 {
  padding-top: 4px;
}
.pt-2 {
  padding-top: 8px;
}
.pt-3 {
  padding-top: 16px;
}
.pt-4 {
  padding-top: 32px;
}
.p-1 {
  padding: 4px;
}
.p-2 {
  padding: 8px;
}
.p-3 {
  padding: 16px;
}
.p-4 {
  padding: 32px;
}

.py-1 {
  padding: 4px;
}

.full-w {
  width: 100%;
}
.half-w {
  width: 50%;
}
.full-h {
  height: 100%;
}
.align-end {
  align-items: end;
}

.justify-self-center {
  justify-self: center;
}

.justify-self-end {
  justify-self: end;
}


.hidden-border {
  border: none !important;
}
.no-border {
  border: none !important;
}

.gap-1 { 
  gap: 4px
}

.gap-2 {
  gap: 8px
}

.gap-3 {
  gap: 12px
}

.width-100px {
  width: 100px;
}
.p-unset {
  padding: unset !important;
}
.bg-white {
  background-color: #fff;
}
  
.modal-common {
  .ant-modal-footer {
    display: flex;
    justify-content: center;

    .ant-btn {
      height: 40px;
      border-radius: 4px;

      span {
        font-size: 15px;
      }
    }

    .ant-btn-primary, .ant-btn-primary:focus, .ant-btn-primary:hover {
      color: #fff;
      border-color: #174a83;
      background: #174a83;
    }
  }
}
.menu-right-header {
  display: flex !important;
  flex-direction: column !important;
  background-color: #fff !important;
  eight: 90px !important;
  padding: 4px 20px !important;
  gap: 8px !important;
  width: 400px;
  margin-left: -16px;
  margin-top: -18px;
}

.right-header-item {
  display: flex !important;
  justify-content: space-between !important;
  margin: 2px 0px !important;

  .btn-selected {
    color: #40a9ff !important;
    border-color: #40a9ff !important;
  }

  .right-header-content {
    display: flex !important;

    button {
      color: rgba(141, 141, 141, 1);
      border-color: rgba(141, 141, 141, 1);
    }

    .right-header-content-button {
      padding: 2px 4px !important;
      border: 1px solid #fff !important;
      border-radius: 4px !important;
      max-height: 30px !important;
      cursor: pointer !important;

      & span {
        color: rgba(141, 141, 141, 1) !important;
      }
    }

    .right-header-content-text {
      display: flex !important;
      margin-left: 8px !important;
      margin-right: 8px !important;

      & span {
        color: rgba(141, 141, 141, 1) !important;
        display: flex !important;
        align-items: center !important;
      }

      .right-header-content-email {
        max-width: 360px !important;
        flex-wrap: wrap !important;
      }

      .wrap-icon {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;

        & svg {
          margin: 0 !important;
        }
      }
    }
  }
}

.right-header-logout {
  background-color: red !important;
  border-radius: 8px !important;
  padding: 4px 8px !important;
  cursor: pointer !important;

  & span {
    color: rgba(141, 141, 141, 1) !important;
  }
}

.ant-tabs-top>.ant-tabs-nav {
  margin: 0;
  padding-top: 0;
  border-bottom: 1px solid #bcbcbc;

  &:before {
    border-bottom: none;
  }
}

.ant-tabs-tab {
  min-width: 96px;
  height: 36px;
  padding: 0;
  margin: 1px !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: #fff;
  border-bottom: none;
   background-color: #aac8f3;

  &.ant-tabs-tab-active {
    background-color: #1890ff;
    border: 1px solid #1890ff;

    .ant-tabs-tab-btn {
      color: #fff !important;
    }
  }

  .ant-tabs-tab-btn {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 32px;
  }
}

.ant-tabs-ink-bar {
  background: #164B7C;
}

.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar-animated {
  transition: width 0.03s,left 0.03s,right 0.03s;
}

.header {
  margin-left: -36px;
  margin-right: 0;
  width: calc(100% + 72px);
  margin-top: -4px;
  padding-left: 36px;
  background-color: #fff;
  margin-bottom: 16px;
  height: 42px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: #1e3666;
  }
}

.background-white {
  background-color: #fff;
}

.grid {
  line {
    stroke: #bcbcbc;
    stroke-width: 2px;

    &[y1="0"] {
      stroke-width: 1px;
    }
    &[x1="0"] {
      stroke-width: 2px;
    }
  }
}

.calendar {
  rect {
    stroke: #bcbcbc;
    stroke-width: 2px;
  }
  line {
    stroke: #bcbcbc;
    stroke-width: 2px;
  }
}

.calendarTop {
  line[y1="0"] {
    stroke-width: 1px;
  }
}

.rowLines {
  line[y1="0"] {
    stroke-width: 0px;
  }
}

.ant-table-content,
.table-main:not(.scroll-df) {
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background: rgba(30, 54, 102, 1);
    margin-left: 10px;
    margin-right: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(30, 54, 102, 1);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
.ant-modal {
  padding: 0;
}
.ant-btn-background-ghost.ant-btn-primary {
  color: #174a83;
  border-color: #174a83;

  &:hover {
    color: #1890ff;
    border-color: #1890ff;
  }
}

.align-right {
  text-align: right;
}
.align-center {
  text-align: center;
}
.ant-notification {
  z-index: 10010;
}

.ant-tooltip-inner {
  padding: 6px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.ant-tooltip {
  max-width: 500px;
}
.ant-popover-buttons {
  display: flex;
  justify-content: center;
}
.position-relative {
  position: relative;
}
.custom-select-editable.ant-select-dropdown {
  min-width: 120px !important;
  max-width: 250px !important;
  width: "100%" !important;

  .ant-select-item-option-content {
    font-size: 11px !important;
    width: 100% !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;

  }
}

.textTruncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ant-notification-notice-message {
  padding-right: 16px !important;
}

.d-none {
  display: none;
}


.tab-custom {
  .ant-tabs-nav {
    &::before {
      border-bottom: none;
       background: transparent !important;
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab {
    box-shadow: none;
    border: none !important;
    border-radius: 6px 6px 0 0 !important;
    margin: 0 1px !important;
    padding: 0 !important;
    min-width: 110px !important;
    .ant-tabs-tab-btn {
      padding: 8px ;
      font-size: 16px;
      font-weight: 500;
    }
  }


  .ant-tabs-tab:not(.ant-tabs-tab-active):not(.ant-tabs-tab-disabled) {
    background-color:  var(--inactive-color);
    border: none !important;

    .ant-tabs-tab-btn {
      color: #ffffff;
    }

    &:hover {
      background-color: var(--active-color);

      .ant-tabs-tab-btn {
        color: #ffffff;
      }
    }
  }


  .ant-tabs-tab.ant-tabs-tab-active {
   
    border: none !important;

    .ant-tabs-tab-btn {
      color: #ffffff !important;
       background-color: var(--active-color);
       border-radius: 6px 6px 0 0 ;
    }
  }


  .ant-tabs-tab.ant-tabs-tab-disabled {
    background-color: var(--disable-color);
    border: none !important;

    .ant-tabs-tab-btn {
      color: #ffffff;
    }
  }

  .ant-popconfirm .ant-btn-primary {
      background: ${MENU_COLORS.PRIMARY} !important;
      color: ${MENU_COLORS.TEXT_WHITE} !important;
      border-radius: 4px !important;
      min-width: 60px !important;
      order: 1 !important;
    }
  .ant-popconfirm .ant-btn-default {
      border-color: ${MENU_COLORS.DELETE_ALL} !important;
      background: ${MENU_COLORS.DELETE_ALL} !important;
      color: ${MENU_COLORS.TEXT_WHITE} !important;
      border-radius: 4px !important;
      min-width: 60px !important;
      order: 2 !important;
      margin-left: 8px !important;
  }
}

.filter-wrapper {
  .ant-tree-checkbox {
    margin: 4px 0px 0 0 !important;
  }
  
  .ant-tree-node-content-wrapper {
    padding: 0 !important;
    padding-left: 2px !important;
  }
  .ant-tree-treenode {
    padding: 0 !important;
    height: 20px !important;
  }
  .ant-checkbox-wrapper {
    span {
      padding: 1px;
    }
  }
}

.blinking-attention {
  animation: var(--animation-blink)
}

@keyframes blink-strong {
  0%,
  100% {
    background-color: rgb(228, 126, 113);
  }
  50% {
    background-color: white;
    color: rgb(11, 70, 141);
  }
}
  .input:disabled, 
  .ant-input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  }
`;

export default GlobalStyles;
